import { IconProps } from "@radix-ui/react-icons/dist/types";

const ChatHistoryIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M15.3422 14.185C14.0182 15.5091 11.8719 15.5091 10.5487 14.185C9.22466 12.861 9.22466 10.7147 10.5487 9.3915C11.8719 8.0675 14.0182 8.0675 15.3422 9.3915C16.6662 10.7147 16.6662 12.861 15.3422 14.185ZM15.3422 14.185L17.1787 16.0215"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 3.95831H17.5M2.5 9.58328H6.25M2.5 15.2083H6.25"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChatHistoryIcon;
